import React from 'react';
import { HTMLTrans } from '../Common/Translations';

const Disclaimer = (props) => {
  const {
    storeCode,
    tRoute
  } = props;

  const termsOfUse = tRoute('/return-policy/terms-of-use');
  const privacyPolicy = tRoute('/return-policy/privacy-policy/');

  if (storeCode == 'PBEU' || storeCode == 'PBUK') {
    return (
      <div>
        <div className="form-check">
          <label className="custom-control custom-checkbox">
            <input type="checkbox" className="custom-control-input" id="subscribeNewsletterCheckbox" />
            <span className="custom-control-indicator" />
            <span className="custom-control-description">
              <small>
                <HTMLTrans id='navbar.auth_disclaimer_eu_2'>
                  Subscribe me for exclusive email offers
                </HTMLTrans>
              </small>
            </span>
          </label>
        </div>
        <div className="mb-3">
          <small>
            <HTMLTrans id='navbar.auth_disclaimer_eu_1' variables={{"termsOfUse": termsOfUse, "privacyPolicy": privacyPolicy}}>
              By registering, you agree to Photobook's <a href={termsOfUse}>Terms of Use</a> and <a href={privacyPolicy}>Privacy Policy</a>.
                </HTMLTrans>
          </small>
        </div>
      </div>
    )
  }

  return (
    <div className="mb-3">
      <small>
        <HTMLTrans id='navbar.auth_disclaimer_non_eu' variables={{"termsOfUse": termsOfUse, "privacyPolicy": privacyPolicy}}>
          By registering, you agree to Photobook's <a href={termsOfUse}>Terms of Use</a> and <a href={privacyPolicy}>Privacy Policy</a>. In addition, you will be subscribed to receive exclusive email offers.
        </HTMLTrans>
      </small>
    </div>
  )
};

export default Disclaimer;


// WEBPACK FOOTER //
// ./src/Auth/Disclaimer.js